import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=2990d5d0&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=ts&"
export * from "./newsList.vue?vue&type=script&lang=ts&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=2990d5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990d5d0",
  null
  
)

export default component.exports